/* eslint-disable security/detect-object-injection */
import React, { useState, useEffect } from 'react'

export default function Progressbar({ max,
    min, OrderValue, criteriaObject, i, chnaging, offerData, viewData, GetOfferData, updateAmount, setupdateAmount, quantity,
    ViewOffer, subsequentOrder, currentItems, criteriaMainObject,
    specialRecurring, }) {
    const [filled, setFilled] = useState(0);
    const [isRunning, setIsRunning] = useState(false);
    setTimeout(() => {
        setIsRunning(true)
    }, 5000);
    useEffect(() => {
        setFilled(0)
        let width = (OrderValue / max) * 100
        if (width > 100) {
            width = 100;
        }
        setTimeout(() => {
            setFilled(width)
        }, 1000);
    }, [criteriaObject])
    const handleColor = () => {
        let color = ''

        // if (specialRecurring) {
        //     debugger
        //     console.log(criteriaMainObject?.subsequent_order,'opop')
        //     if (criteriaMainObject?.subsequent_order) {
        //         if (currentItems > ViewOffer?.minimum_cap) {
        //             color = 'rgb(33 181 70)'
        //         } else {
        //             color = '#555259'
        //         }
        //     } else {
        //         if (min <= OrderValue <= max) {
        //             color = 'rgb(33 181 70)'
        //         } else {
        //             color = '#555259'
        //         }
        //     }
        // } else {
        if ((OrderValue < min || OrderValue > max)) {
            color = '#555259'
        }
        else {
            color = 'rgb(33 181 70)'
        }
        // }
        // if ((OrderValue < min || OrderValue > max) && !(specialRecurring && OrderValue < ViewOffer?.minimum_cap)) {
        //     color = '#555259'
        // }
        // else {
        //     color = 'rgb(33 181 70)'
        // }

        return color;
    }
    return (
        <div>
            <div className="progressbar">
                <div style={{
                    height: "100%",
                    width: `${filled}%`,
                    backgroundColor: handleColor(),
                    transition: "width 1.5s"
                }}></div>
            </div>
        </div>
    )
}